import { useState, useEffect, RefObject } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchReviewsRequestAction, setCurrentFilter } from 'src/effects/Reviews/actions'
import { getIsFetching } from 'src/effects/Reviews/selectors'
import { useIntersection } from 'react-use'

interface IUseFetchReviewsProps {
  propertyId?: number
  language: string
  ref: RefObject<HTMLDivElement>
}

export function useFetchReviews({ propertyId, language, ref }: IUseFetchReviewsProps) {
  const dispatch = useDispatch()
  const reviewsInt = useIntersection(ref, { root: null })
  const onScreen = !!reviewsInt?.isIntersecting
  const isLoading = useSelector(getIsFetching)

  const [reviewsDisplayed, setReviewsDisplayed] = useState(false)

  useEffect(() => {
    if (propertyId && !reviewsDisplayed && !isLoading && onScreen) {
      dispatch(fetchReviewsRequestAction({ propertyId, language, page: 1 }))
      dispatch(setCurrentFilter({ filter: undefined }))
      setReviewsDisplayed(true)
    }
  }, [dispatch, isLoading, language, onScreen, reviewsDisplayed, propertyId])
}
